import React from 'react'
import FloatingCoin from './FloatingCoin.js'
import '../../styles/IncreaseValueOverTimeStyles/increasevalueovertime.css'
import rocket from './../../resources/IncreaseValueOverTimeResources/rocket.svg'
import rocketflames from './../../resources/IncreaseValueOverTimeResources/rocket-flames.svg'

import growth from './../../resources/IncreaseValueOverTimeResources/growth.svg'
import '../../styles/IncreaseValueOverTimeStyles/increasevalueovertime3.css'
import hand from './../../resources/IncreaseValueOverTimeResources/hand.svg'

import {connect} from 'react-redux'
class IncreaseValueOverTime extends React.Component{
    render(){
        return(
            <section className="ivot__container" id='kronn-coin-anchor'>
                <div className="ivot__3">
                    {(this.props.windowDimensions.windowWidth > 1080) ?
                        null
                        :
                        <div className="ivot__instant-transactions">
                            <div className="ivot__rocket-container">
                                <img className="ivot__rocket" src={rocket} />
                                <img className="ivot__rocket-flames" src={rocketflames} />
                            </div>
                            <div>Instant transactions</div>
                        </div>
                    }
                    <div className="ivot__inflationary">
                        <div className="ivot__growth-container">
                            <img className="ivot__growth" src={growth} />
                            <div className="ivot__growth-node-1"/>
                            <div className="ivot__growth-node-2"/>
                            <div className="ivot__growth-node-3"/>
                            <div className="ivot__growth-node-4"/>
                        </div>
                        <div>Inflationary</div>
                    </div>

                    {(this.props.windowDimensions.windowWidth > 1080) ?
                        null
                        :
                        <div className="ivot__zero-fees">
                            <div className="ivot__hand-container">
                                <img className="ivot__hand" src={hand} />
                            </div>
                            <div>Zero Fees</div>
                        </div>
                    }
                </div>

                <div className="ivot__3-fc3">

                    {(this.props.windowDimensions.windowWidth > 1080) ?
                        <div className="ivot__instant-transactions" style={{marginBottom: '125px'}}>
                            <div className="ivot__rocket-container">
                                <img className="ivot__rocket" src={rocket} />
                                <img className="ivot__rocket-flames" src={rocketflames} />
                            </div>
                            <div style={{marginTop: 20}}>Instant transactions</div>
                        </div>
                        :
                        null
                    }
                    <div className="ivot__3-fc">
                        <FloatingCoin />
                    </div>
                    {(this.props.windowDimensions.windowWidth > 1080) ?
                        <div className="ivot__zero-fees" style={{marginBottom: '125px'}}>
                            <div  className="ivot__hand-container">
                                <img className="ivot__hand" src={hand} />
                            </div>
                            <div>Zero Fees</div>
                        </div>
                        :
                        null
                    }

                </div>

                <div>
                    <h1 className="title" style={{textAlign: 'left', marginBottom: '25px', marginTop: '40px'}}>
                        Light, usable and investable
                    </h1>
                    <div className="text" style={{textAlign: 'left', fontWeight: '400'}}>
                        The KRONN Coin is forked on Nano, an exciting currency based on the novel block-lattice architecture which renders transfers fee-less, instantaneous and infinitely scalable. <br/><br/>
                        Our coin is ideal for peer-to-peer transactions, trading and day to day purchases, large or small.  <br/><br/>
                        The coin can also be used as cheaper gas OR as a share in our broad range of exchange services given that all transaction fees are regularly distributed to KRONN Coin holders in proportion to the amount that is dormant in their wallets.
                    </div>
                </div>
            </section>
        )
    }
}
const mapStatesToProps = (state) =>{
    return{
        windowDimensions: state.windowDimensions,
    }
}


export default connect(mapStatesToProps)(IncreaseValueOverTime)



// WEBPACK FOOTER //
// ./src/components/IncreaseValueOverTime/IncreaseValueOverTime.js